import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

// STYLES
import { SliderContainer, SlidingRadioInput, StyledLabel, StyledSlider } from '../styles';

// ASSETS
import CircleGeofenceIcon from 'assets/CircleGeofenceIcon';
import PolygonGeofenceIcon from 'assets/PolygonGeofenceIcon';

type SliderPropsType = {
  ovalToolSelected: boolean;
  handleSelectOvalTool: () => void;
  handleSelectPolygonTool: () => void;
};

export const Slider = (props: SliderPropsType) => {
  const { ovalToolSelected, handleSelectOvalTool, handleSelectPolygonTool } = props;

  const [sliderPosition, setSliderPosition] = useState(ovalToolSelected ? 1 : 0);

  const handleSliderChange = (value: number) => {
    if (sliderPosition !== value) {
      setSliderPosition(value);
    }
  };

  return (
    <SliderContainer>
      <SlidingRadioInput>
        <StyledSlider $position={ovalToolSelected ? 1 : 0} />
        <StyledLabel
          onClick={() => {
            handleSliderChange(0);
            handleSelectPolygonTool();
          }}
          $checked={!ovalToolSelected}
          $disabled={false}
        >
          <PolygonGeofenceIcon color="currentColor" />
          <FormattedMessage id="views.FleetSettings.Geofencing.types.polygon" />
        </StyledLabel>
        <StyledLabel
          onClick={() => {
            handleSliderChange(1);
            handleSelectOvalTool();
          }}
          $checked={ovalToolSelected}
        >
          <CircleGeofenceIcon color="currentColor" />
          <FormattedMessage id="views.FleetSettings.Geofencing.types.circle" />
        </StyledLabel>
      </SlidingRadioInput>
    </SliderContainer>
  );
};

export default Slider;
